import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{staticClass:"mt-5 pt-5 text-xs-center",attrs:{"cols":"12","sm":"6","md":"4"}},[_c(VCard,[_c(VCardText,[_c(VImg,{staticClass:"my-3",attrs:{"src":require('@/assets/logo.png'),"contain":"","height":"100"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }